import { Component, Input, OnInit } from '@angular/core';
import { SsoSettingsResource } from '../resources/sso-settings.resource';
import { Growl } from 'angular/custom/services/growl.service';
import { ErrorHandlerService } from 'angular/custom/services/error-handler.service';
import { finalize } from 'rxjs/operators';
import { StoragePeriodTypeConstants } from '../constants/StoragePeriodTypeConstants';
import { Observable } from 'rxjs';

@Component({
    selector: 'pkp-storage-period-type-picker',
    template: require('./storage-period-type-picker.component.html')
})
export class StoragePeriodTypePickerComponent implements OnInit {
    private _selectedPeriodTypes: StoragePeriodType[];
    @Input() set selectedPeriodTypes(value: StoragePeriodType[]) {
        this._selectedPeriodTypes = value;
        this.remainingPeriodTypes = this.findAndFormatRemainingPeriodTypes();
    }
    get selectedPeriodTypes() {
        return this._selectedPeriodTypes;
    }

    @Input() saveObservableLambda: (
        StoragePeriodType
    ) => Observable<StoragePeriodType>;
    @Input() deleteObservableLambda: (
        StoragePeriodType
    ) => Observable<StoragePeriodType>;

    @Input() disabled: boolean = false;

    deletingProductPeriod: StoragePeriodType[] = [];
    savingProductPeriod: boolean = false;

    readonly allPeriodTypes: {
        [key in StoragePeriodType]: string;
    } = StoragePeriodTypeConstants.asDict();

    remainingPeriodTypes: {
        value: StoragePeriodType;
        [label: string]: string;
    }[] = [];

    constructor(
        private ssoSettingsResource: SsoSettingsResource,
        private growl: Growl,
        private errorHandlerService: ErrorHandlerService
    ) {}

    ngOnInit(): void {}

    addProductPeriod(periodType: StoragePeriodType) {
        this.savingProductPeriod = true;

        this.saveObservableLambda(periodType)
            .pipe(finalize(() => (this.savingProductPeriod = false)))
            .subscribe((res) => {
                this.growl.show('Successfully added.', 'success');
                this.selectedPeriodTypes.push(res);
                this.remainingPeriodTypes =
                    this.findAndFormatRemainingPeriodTypes();
            }, this.errorHandlerService.handle.bind(this));
    }

    deleteProductPeriod(periodType: StoragePeriodType) {
        const idxOfDeletingPeriodType =
            this.deletingProductPeriod.push(periodType);

        this.deleteObservableLambda(periodType)
            .pipe(
                finalize(() =>
                    this.deletingProductPeriod.splice(
                        idxOfDeletingPeriodType - 1,
                        1
                    )
                )
            )
            .subscribe(() => {
                this.growl.show('Successfully removed.', 'success');
                this.selectedPeriodTypes.splice(
                    this.selectedPeriodTypes.findIndex(
                        (pT) => pT === periodType
                    ),
                    1
                );
                this.remainingPeriodTypes =
                    this.findAndFormatRemainingPeriodTypes();
            }, this.errorHandlerService.handle.bind(this));
    }

    private findAndFormatRemainingPeriodTypes(): {
        value: StoragePeriodType;
        [label: string]: string;
    }[] {
        return Object.keys(this.allPeriodTypes)
            .filter(
                (value) =>
                    this.selectedPeriodTypes.indexOf(
                        value as StoragePeriodType
                    ) === -1
            )
            .map((value) => ({
                label: this.allPeriodTypes[value],
                value: value as StoragePeriodType
            }));
    }
}
